export default function MidCTA() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://lirp.cdn-website.com/785a78af/dms3rep/multi/opt/Shadow-roofing-and-solar-8-1920w.webp"
          alt="Aerial view of a South Bay home with completed roofing and solar installation by Shadowfax"
          className="w-full h-full object-cover object-top"
        />
        <div
          className="absolute inset-0"
          style={{ background: 'linear-gradient(100deg, rgba(4,10,20,0.97) 0%, rgba(6,15,26,0.88) 50%, rgba(6,15,26,0.65) 100%)' }}
        ></div>
      </div>

      {/* Gold top line */}
      <div
        className="absolute top-0 left-0 right-0 h-px"
        style={{ background: 'linear-gradient(to right, transparent, rgba(212,175,55,0.5) 30%, rgba(212,175,55,0.5) 70%, transparent)' }}
      ></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-14">

          {/* Left */}
          <div className="max-w-xl">
            <span
              className="text-[#d4af37] text-[10px] uppercase tracking-[4px] font-bold block mb-6"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Ready to Get Started?
            </span>
            <h2
              className="font-black text-white leading-tight mb-6"
              style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 'clamp(2.2rem, 4vw, 3.5rem)', letterSpacing: '-0.02em' }}
            >
              Upgrade Your Roof.
              <br />
              <span className="text-[#d4af37]">Power Your Home.</span>
            </h2>
            <p
              className="text-white/50 text-base leading-[1.8]"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Contact Shadowfax Roofing &amp; Solar in Campbell to schedule your free inspection and get a detailed, no-pressure estimate for your roofing or solar project.
            </p>
          </div>

          {/* Right — CTAs */}
          <div className="flex flex-col gap-4 flex-shrink-0 w-full lg:w-auto">
            <button
              onClick={() => handleNav('#contact')}
              className="group flex items-center justify-center gap-3 text-[#1a1a1a] font-bold text-xs px-12 py-5 rounded transition-all duration-300 cursor-pointer whitespace-nowrap uppercase tracking-[2px]"
              style={{ fontFamily: "'Montserrat', sans-serif", background: '#d4af37' }}
              onMouseEnter={e => (e.currentTarget.style.background = '#c4a030')}
              onMouseLeave={e => (e.currentTarget.style.background = '#d4af37')}
            >
              Get Your Free Estimate
              <div className="w-5 h-5 flex items-center justify-center group-hover:translate-x-1 transition-transform duration-300">
                <i className="ri-arrow-right-line"></i>
              </div>
            </button>
            <a
              href="tel:4086280065"
              className="flex items-center justify-center gap-3 border border-white/20 hover:border-[#d4af37]/60 text-white hover:text-[#d4af37] font-semibold text-xs px-12 py-5 rounded transition-all duration-300 whitespace-nowrap uppercase tracking-[2px]"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill"></i>
              </div>
              Call (408) 628-0065
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
